import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-cancelbooking',
  templateUrl: './cancelbooking.page.html',
  styleUrls: ['./cancelbooking.page.scss'],
})
export class CancelbookingPage implements OnInit {
  bookingId: any;
  bookingAmnt: any;
  searchData: { bookingId: any; bookingAmnt: any; };


  constructor(
    public modalCtrl: ModalController,
    public addCall: AddCall,
  ) { }

  ngOnInit() {
  }

  dismiss(value) {
    this.searchData = {
      "bookingId": this.bookingId,
      "bookingAmnt": this.bookingAmnt,
    };
    if (value == 1) {
      this.modalCtrl.dismiss(this.searchData);
    }
    else {
      this.modalCtrl.dismiss();
    }
  }
}
